import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    ViewEncapsulation,
} from "@angular/core";
import { S25DropdownAbstract } from "../s25.dropdown.abstract";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { BpeVarsConst } from "../../bpe/s25.bpe.const";
import { Doc } from "../../system-settings/document-management/s25.document.const";
import { DropDownItem } from "../../../pojo/DropDownItem";

@TypeManagerDecorator("s25-bpe-vars-dropdown")
@Component({
    selector: "s25-bpe-vars-dropdown",
    template: `
        @if (this.items) {
            <s25-generic-dropdown
                [items]="this.items"
                [(chosen)]="this.chosen"
                [onSelect]="this.onSelect"
                (chosenChange)="onChosenChange($event)"
                [searchEnabled]="true"
                [placeholder]="placeholder"
                [hasNoneItem]="hasNoneItem"
                [scrollIntoView]="scrollIntoView"
                [readOnly]="readOnly"
            ></s25-generic-dropdown>
        }
    `,
    styles: ``,
    encapsulation: ViewEncapsulation.Emulated,
    changeDetection: ChangeDetectionStrategy.Default,
    standalone: false,
})
export class S25BpeVarsDropdownComponent extends S25DropdownAbstract implements OnInit, OnChanges {
    @Input() type?: keyof typeof BpeVarsConst.Items;
    @Input() types?: (keyof typeof BpeVarsConst.Items)[];
    @Input() placeholder: string;
    @Input() documentType: Doc.TypeId;
    @Input() itemFilter: (items: DropDownItem[]) => DropDownItem[] | Promise<DropDownItem[]>;
    @Input() dataTypes?: string[];

    constructor(private changeDetector: ChangeDetectorRef) {
        super();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.type || changes.documentType || changes.types || changes.itemFilter || changes.dataTypes) {
            this.setItems();
        }
    }

    ngOnInit() {
        this.setItems();
    }

    async setItems() {
        const types = this.types || (this.type ? [this.type] : ["event"]);
        this.items = types.flatMap((type) => (BpeVarsConst.Items[type] as DropDownItem[]) || []);
        if (this.itemFilter) {
            this.items = await this.itemFilter(this.items);
        }
        if (this.documentType) {
            this.items = this.items.filter(
                (item) => !item.documentTypes || item.documentTypes.includes(this.documentType),
            );
        }
        if (this.dataTypes) {
            this.items = this.items.filter((item) => this.dataTypes.includes(item.type));
        }
        this.changeDetector.detectChanges();
    }
}

export type VariableWithOptions = {
    val?: string;
    txt?: string;
    options?: {
        type: VariableOptionType;
        id: string;
        label?: string;
        substitute?: string;
        prop?: string;
        hidden?: boolean;
        data?: any;
        documentTypes?: Doc.TypeId[];
        options?: VariableWithOptions[];
    }[];
    hasFormat?: boolean;
    vars?: { var: string; options: Record<string, boolean> }[];
    noPre?: boolean;
    type?: string;
};

export type VariableOptionType =
    | "checkbox"
    | "toggle"
    | "dropdown"
    | "roleDropdown"
    | "custom"
    | "searchCriteriaItem"
    | "searchCriteriaItems";
